export enum SelectedDefinitionActionType {
  ManageDefinition = 'ManageDefinition',
  UpdateDefinition = 'UpdateDefinition',
  UpdateDefinitionSuccess = 'UpdateDefinitionSuccess',
  UpdateDefinitionFailed = 'UpdateDefinitionFailed',
  PollDefinitionRun = 'PollDefinitionRun',
  PollDefinitionRunFailed = 'PollDefinitionRunFailed',
  DeleteDefinition = 'DeleteDefinition',
  DeleteDefinitionSuccess = 'DeleteDefinitionSuccess',
  DeleteDefinitionFailure = 'DeleteDefinitionFailure',
  ExecuteDefinitionRun = 'ExecuteDefinitionRun',
  ExecuteDefinitionRunFailed = 'ExecuteDefinitionRunFailed',
  CancelPollDefinitionRun = 'CancelPollDefinitionRun',
  CancelDefinitionQueryRun = 'CancelDefinitionQueryRun',
  CancelDefinitionQueryRunSuccess = 'CancelDefinitionQueryRunSuccess',
  CancelDefinitionQueryRunFailed = 'CancelDefinitionQueryRunFailed',
  DefinitionReportRunLoadSuccess = 'DefinitionReportRunLoadSuccess',
  DefinitionReportRunLoadFailure = 'DefinitionReportRunLoadFailure',
  PollDefinitionRunComplete = 'PollDefinitionRunComplete',
  LoadDefinitionQuerySuccess = 'LoadDefinitionQuerySuccess',
  LoadDefinitionQueryRunSuccess = 'LoadDefinitionQueryRunSuccess',
  LoadDefinitionQueryRunFailure = 'LoadDefinitionQueryRunFailure',
  LoadDefinitionQueryResultSuccess = 'LoadDefinitionQueryResultSuccess',
  LoadDefinitionQueryResultFailure = 'LoadDefinitionQueryResultFailure',
  UpdateDefinitionSource = 'UpdateDefinitionSource',
}
